import { FC } from 'react';

import { Steps } from 'antd';
import { useTranslation } from 'react-i18next';

import styles from './StepNavigation.module.scss';

const { Step } = Steps;

interface StepNavigationProps {
    currentStep: number;
}

const StepNavigation: FC<StepNavigationProps> = ({ currentStep }) => {
    const { t } = useTranslation();

    return (
        <div className={styles['step-navigation']}>
            <Steps
                current={currentStep}
                className={styles['steps']}
                labelPlacement="horizontal"
            >
                <Step
                    title={t('shareDrawer.steps.addItemsAndRecipients')}
                    className={styles['step-item']}
                />
                <Step
                    title={t('shareDrawer.steps.selectPolicy')}
                    className={styles['step-item']}
                />
            </Steps>
        </div>
    );
};

export default StepNavigation;
